export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";